<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickFinalize">
        <div class="row">
            <div class="col-12">
                <div>{{ record.message }}</div>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-submit @click="clickFinalize" v-if="showButtonIndex" text="Ir al listado"></x-button-submit>
                <x-button-submit @click="clickNewDocument" v-if="showButtonNew"></x-button-submit>
            </div>
        </div>
    </x-modal>
</template>

<script>

import XButtonCancel from "../../../../components/Form/XButtonCancel";
import XButtonSubmit from "../../../../components/Form/XButtonSubmit";
import XModal from "../../../../components/XModal";

export default {
    name: 'PurchaseFinish',
    components: {XModal, XButtonSubmit, XButtonCancel},
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
        resource: {
            type: String,
            required: true,
        },
        record: {
            required: true,
        },
        showButtonIndex: {
            type: Boolean,
            default: true,
        },
        showButtonNew: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            title: null,
            loading: false,
        }
    },
    methods: {
        handleOpen() {
            this.title = 'Finalizar'
            this.message = this.record.message;
        },
        clickFinalize() {
            location.href = `/${this.resource}`
        },
        clickNewDocument() {
            this.clickClose()
        },
        clickClose() {
            this.$emit('update:showDialog', false)
            this.initForm()
        },
    }
}
</script>
